import { Checkbox, Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IResultadoItemNFSE } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { NfseItemDialog } from "./item-detail/ItemDialogNFSE";

const numeral = require("numeral");

interface Props {
  items: any[];
  modelo: string;
  data: any;
  entrada_saida: string;
}

@observer
export class DetalhamentoNfseTable extends React.Component<Props, {}> {

  obs = observable({
    viewing: null as any,
  });

  handleContest(item: any) {
    this.onSelect(item, true);
    ResultadoStore.obs.openContestacaoLote = true;
  }

  handleView(item: any) {
    this.obs.viewing = item;
  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  onSelectAll = async (isSelect: boolean) => {
    if (isSelect) {
      let data = this.props.items
        ?.filter(item => !this.isProcessing(item._id))
        .map(item => ({
          id: item._id,
          data: item.data,
        }));
      ResultadoStore.setContestarItemsList(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  onSelect = async (item: any, checked: boolean) => {
    let data = {
      id: item._id || item.id,
      data: item.data,
    };
    if (checked) {
      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item._id || item.id);
    }
  };

  isSelected(id: string) {
    return ResultadoStore.obs.contestarItems?.some(v => v.id === id) || false;
  }

  isProcessing(id: string) {
    return ResultadoStore.obs.itens_processando.indexOf(id) !== -1;
  }

  isAllSelected() {
    const selectable = this.props.items?.filter(item => !this.isProcessing(item._id)) || [];
    if (!selectable.length) return false;
    return selectable.every(item => this.isSelected(item._id));
  }

  isWarningCard(item: IResultadoItemNFSE): boolean {
    if (item.competencia) {
      const competencia = moment(item.competencia).format("MM/YYYY");
      const dataCalculo = moment(item.data_calculo).format("MM/YYYY");
      if (competencia !== dataCalculo) return true;
    }
    return false;
  }

  renderActions(item: IResultadoItemNFSE) {
    const niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    const isDisabled = niveis_acesso.indexOf("c2") === -1;

    if (!AppStore.obs1.usuario) return null;

    if (this.isProcessing(item._id)) {
      return (
        <div className="detalhamento-card-actions">
          <button className="detalhamento-action-btn" onClick={() => this.handleView(item)}>
            <img src="/images/contestar.svg" width={20} />
          </button>
          <Tooltip content="Processando...">
            <img src="/images/icone-relogio.png" width={24} />
          </Tooltip>
        </div>
      );
    }

    return (
      <div className="detalhamento-card-actions">
        <Tooltip content="Detalhes">
          <button className="detalhamento-action-btn" onClick={() => this.handleView(item)}>
            <img src="/images/contestar.svg" width={20} />
          </button>
        </Tooltip>
        {!isDisabled && (<>
          {item.calculo_memoria_salva 
            ? <Tooltip content="Contestado via memória">
              <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
                <img src="/images/contestado_memoria.png" width={20} />
              </button>
            </Tooltip>
            : item.contestacao_calc_id
              ? <Tooltip content="Contestado">
                <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
                  <img src="/images/contestado.png" width={20} />
                </button>
              </Tooltip>
              : <Tooltip content="Contestar">
                <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
                  <img src="/images/contestar.png" width={20} />
                </button>
              </Tooltip>
          }
        </>)}
      </div>
    );
  }

  renderViewDialog() {
    return (
      <NfseItemDialog
        modelo={this.props.modelo}
        item={this.obs.viewing}
        data={this.props.data}
        onClose={this.handleViewClose}
        entrada_saida={this.props.entrada_saida}
      />
    );
  }

  renderCard(item: IResultadoItemNFSE) {
    const id = item._id;
    const selected = this.isSelected(id);
    const isProcessing = this.isProcessing(id);
    const isWarning = this.isWarningCard(item);

    const cardClasses = [
      "detalhamento-card",
      isWarning ? "card-warning" : "",
      selected ? "card-selected" : "",
    ].filter(Boolean).join(" ");

    return (
      <div key={id} className={cardClasses}>
        {/* Header */}
        <div className="detalhamento-card-header">
          <div className="detalhamento-card-header-left">
            {!isProcessing && (
              <Checkbox
                checked={selected}
                onChange={(e) => this.onSelect(item, (e.target as HTMLInputElement).checked)}
                style={{ marginBottom: 0 }}
              />
            )}
            <span className="detalhamento-card-descricao">
              {item.descricao?.toUpperCase()}
            </span>
          </div>
          {this.renderActions(item)}
        </div>

        {/* Body */}
        <div className="detalhamento-card-body">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Nota</span>
            <span className="detalhamento-field-value">{item.nnfe || "-"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data</span>
            <span className="detalhamento-field-value">{moment(item.data).format("DD/MM/YYYY")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Competência</span>
            <span className="detalhamento-field-value">
              {item.competencia ? moment(item.competencia).format("DD/MM/YYYY") : "N/A"}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Dt. Cálculo</span>
            <span className="detalhamento-field-value">{moment(item.data_calculo).format("DD/MM/YYYY")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor</span>
            <span className="detalhamento-field-value">{numeral(item.valor).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Deduções</span>
            <span className="detalhamento-field-value">{numeral(item.valor_deducoes).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">PIS</span>
            <span className="detalhamento-field-value">{numeral(item.valor_pis).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">COFINS</span>
            <span className="detalhamento-field-value">{numeral(item.valor_cofins).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">ISS</span>
            <span className="detalhamento-field-value">{numeral(item.valor_iss).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">IR</span>
            <span className="detalhamento-field-value">{numeral(item.valor_ir).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CSLL</span>
            <span className="detalhamento-field-value">{numeral(item.valor_csll).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">INSS</span>
            <span className="detalhamento-field-value">{numeral(item.valor_inss).format("$ 0,0.00")}</span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const allSelected = this.isAllSelected();
    const totalItems = this.props.items?.length || 0;
    const selectedCount = ResultadoStore.obs.contestarItems?.length || 0;

    return (
      <>
        <div className="detalhamento-container">
          <div className="detalhamento-select-all">
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Checkbox
                checked={allSelected}
                indeterminate={selectedCount > 0 && !allSelected}
                onChange={() => this.onSelectAll(!allSelected)}
                style={{ marginBottom: 0 }}
              />
              <span>
                {selectedCount > 0
                  ? `${selectedCount} de ${totalItems} selecionado(s)`
                  : `${totalItems} resultado(s)`
                }
              </span>
            </div>
          </div>

          {this.props.items?.map((item: IResultadoItemNFSE) => this.renderCard(item))}
        </div>

        {this.obs.viewing && this.renderViewDialog()}
      </>
    );
  }
}

export default DetalhamentoNfseTable;
